import { Route, Routes } from "react-router-dom";
import AppThemeTestA from "./AppThemeTest/AppThemeTestA";
import AppThemeTestB from "./AppThemeTest/AppThemeTestB";
import CategoryLandingPage from "./Category/CategoryLandingPage";
import TestResult from "./shared/TestResult";

export default function LandingRoot() {
  const APP_THEME_TEST_PREFIX = 'theme'
  const CATEGORY_PREFIX = 'category'
  const SHARED_PREFIX = 'shared'
  return (
    <Routes>
      <Route path={`${APP_THEME_TEST_PREFIX}/basic`} element={<AppThemeTestA/>}/>
      <Route path={`${APP_THEME_TEST_PREFIX}/brain`} element={<AppThemeTestB/>}/>
      <Route path={`${CATEGORY_PREFIX}/:type`} element={<CategoryLandingPage/>}/>
      <Route path={`${SHARED_PREFIX}/test/result`} element={<TestResult/>}/>
    </Routes>
  )
}
